import React from "react";
import {ChecklistItemModel} from "../../../../../models/checklist-model";
import styles from "../Checklist.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFileImport} from "@fortawesome/free-solid-svg-icons";
import {
    useActiveChecklistItemSelector,
    useAllTaskListSelector,
    useCompletedChecklistMapSelector
} from "../../../../../store/selectors/task/task.selectors";
import FirebaseUsage from "../../../../../firebase/firebase.usage";
import {COLLECTIONS} from "../../../../../firebase/constants";
import * as taskActions from "../../../../../store/actions/task.actions";
import {useDispatch} from "react-redux";
import classNames from "classnames";
import moment from "moment";
import {
    useActiveProjectCalendarsSelector,
    useActiveProjectSelector,
    useCpmMapSelector
} from "../../../../../store/selectors/project.selectors";
import {
    convertDateToIndex,
} from "../../../../../utils/cpm-functions/cpm-app/functions/handleEvent";
import ChecklistUtils from "../../../../../utils/checklist/checklist.utils";
import {useUserSelector} from "../../../../../store/selectors/authorization.selectors";
import ChecklistAttachmentInput from "./ChecklistAttachmentInput";

export default function ChecklistItem(props: {
    checklistItem: ChecklistItemModel,
    title: string,
    index: number,
    completionRecord: any
}) {
    const {checklistItem, title, index, completionRecord} = props;
    // const completedChecklistMap = useCompletedChecklistMapSelector();
    // const completionRecord = completedChecklistMap.get(`${checklistItem.taskId}:${checklistItem.checklistItemId}`);
    const isIncomplete = !completionRecord
    const allTasks = useAllTaskListSelector();
    const dispatch = useDispatch();
    const selectedItem = useActiveChecklistItemSelector();
    const cpmMap = useCpmMapSelector();
    const calendarMap = useActiveProjectCalendarsSelector();
    const dataDate = new Date().setHours(0, 0, 0, 0) / 1000;
    const activeProject = useActiveProjectSelector();
    const user = useUserSelector();

    const completeChecklistItem = async () => {
        const task = allTasks.get(checklistItem.taskId);
        if (!task || !activeProject || !user) return;
        await ChecklistUtils.completeCheckListItem(
            checklistItem.checklistItemId,
            task,
            activeProject.contractId ? activeProject.contractId : 'unknown',
            user
        )
    }

    const uncheckChecklistItem = async () => {
        const task = allTasks.get(checklistItem.taskId);
        if (!task || !activeProject || !user) return;
        await ChecklistUtils.uncheckCheckListItem(
            checklistItem.checklistItemId,
            task,
            activeProject.contractId ? activeProject.contractId : 'unknown',
            user
        )
    }

    const generateDeadline = () => {
        const cpmTask = cpmMap.get(checklistItem.taskId);
        if (!cpmTask) return;
        const workingHours = calendarMap.get(`whd:${cpmTask.cal_id}`)
        const dataDateIndex = convertDateToIndex(dataDate, cpmTask.cal_id, calendarMap);
        const halfHours = checklistItem.tMinusDays > 0 ?
            (cpmTask.lf + (checklistItem.tMinusDays * workingHours * 2)) - dataDateIndex :
            (cpmTask.ls + (checklistItem.tMinusDays * workingHours * 2)) - dataDateIndex;
        const days = Math.floor(halfHours / (workingHours * 2));

        return (<div className={days < 0 ? styles.ChecklistItemDeadlineCritical : styles.ChecklistItemDeadline}>
            {`${Math.floor(days)} day${Math.abs(days) > 1 ? 's' : ''}`}
            {days <= 0 ? <div className={styles.Critical}>
                    <p className={styles.CriticalTag}>Critical</p>
            </div> : days < 5 ? <div className={styles.NearCritical}>
                    <p className={styles.CriticalTag}>Near Critical</p>
            </div> : null}
        </div>)
    }

    const dayString = generateDeadline();

    return (
        <div className={classNames(styles.ChecklistItem, {
            [styles.CheckListItemSelected]: selectedItem && selectedItem.checklistItemId === checklistItem.checklistItemId && selectedItem.taskId === checklistItem.taskId,
        })} onClick={() => {
            const task = allTasks.get(checklistItem.taskId);
            if (!task) return;
            dispatch(taskActions.Actions.setActiveTask(task))
            dispatch(taskActions.Actions.setActiveChecklistItem(checklistItem))
        }}>
            <div className={styles.ChecklistItemLeft}>
                <div className={styles.ChecklistItemIndex}>{checklistItem.completionRecord ? ' ' : checklistItem.index ? checklistItem.index : index}</div>
                <div className={isIncomplete ? styles.ChecklistItemCheckBoxUnchecked : styles.ChecklistItemCheckBoxChecked}
                     onClick={() => {
                         if (isIncomplete) {
                            completeChecklistItem().catch(e => console.error(e));
                         } else {
                            uncheckChecklistItem().catch(e => console.error(e));
                         }
                     }}
                >
                    <FontAwesomeIcon icon={faCheck} size='lg' />
                </div>
                <span>
                      <div className={styles.ChecklistItemName}>{checklistItem.itemName}</div>
                      <div className={styles.ChecklistItemTaskName}>{checklistItem.taskString}</div>
                </span>
                {checklistItem.completionRecord &&
                    <ChecklistAttachmentInput
                        checklistItem={checklistItem}
                        completionRecord={completionRecord}
                        deployment='checklist'
                    />
                }
            </div>
            <div className={styles.ChecklistItemRight}>
                <div className={styles.ChecklistItemDueDate}>{moment(new Date(checklistItem.due * 1000)).format('DD-MMM-YY')}</div>
                {dayString}
            </div>
        </div>
    )
}